export function parseToBoolean(value: boolean | ''): boolean {
  return value === '' || <boolean>value;
}
